import { MouseEvent, ReactNode, useRef, useState, useEffect } from 'react';
import styles from './DropdownMenu.module.css';
import { IconDotsVertical } from '@tabler/icons-react';
import { StyleProps } from './types';

type MenuItem = {
	label: string;
	onClick: () => void;
	disabled?: boolean;
};

type Props = StyleProps & {
	items: MenuItem[];
	icon?: ReactNode;
};

const DropdownMenu = ({ items, icon, className, style }: Props) =>
{
	const [isOpen, setIsOpen] = useState<boolean>(false);
	const containerRef = useRef<HTMLDivElement>(null);

	useEffect(() =>
	{
		document.addEventListener('mousedown', handleClickOutside);
		return () =>
		{
			document.removeEventListener('mousedown', handleClickOutside);
		};
	}, []);

	const handleClickToggle = (event: MouseEvent<HTMLDivElement>) =>
	{
		event.stopPropagation();
		setIsOpen(!isOpen);
	};

	const handleClickItem = (event: MouseEvent<HTMLDivElement>, item: MenuItem) =>
	{
		event.stopPropagation();
		if (!item.disabled)
		{
			item.onClick();
			setIsOpen(false);
		}
	};

	const handleClickOutside = (event: globalThis.MouseEvent) =>
	{
		if (containerRef.current && !containerRef.current.contains(event.target as Node))
		{
			setIsOpen(false);
		}
	};

	return (
		<div ref={containerRef} className={`${styles.dropdownMenu}${isOpen ? ` ${styles.open}` : ''}${className ? ` ${className}` : ''}`} style={style} onClick={handleClickToggle}>
			{icon || <IconDotsVertical />}
			{isOpen && <div className={styles.dropdown}>
				{items.map((item, index) => (
					<div
						className={`${styles.item}${item.disabled ? ` ${styles.disabled}` : ''}`}
						key={index}
						onClick={(e) => handleClickItem(e, item)}
					>
						{item.label}
					</div>
				))}
			</div>}
		</div>
	);
};

export default DropdownMenu;
